var _g, _path, _g2, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConnect = function SvgConnect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 552,
    height: 90,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#connect_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 156,
    y: 13,
    fill: "url(#connect_svg__b)",
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#connect_svg__c)",
    filter: "url(#connect_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176 46a13 13 0 0 1-12.01-8.025 13 13 0 0 1 2.818-14.167 12.998 12.998 0 0 1 20.001 1.97 12.996 12.996 0 0 1-1.617 16.414A13 13 0 0 1 176 46m11.917-13a11.91 11.91 0 0 0-7.357-11.01A11.916 11.916 0 1 0 187.917 33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.083 40.258a.54.54 0 0 1-.525-.422.54.54 0 0 1 .041-.354c.053-.11.141-.2.252-.253a18.9 18.9 0 0 1 4.252-1.479v-1.83a3.53 3.53 0 0 1-1.436-2.78 1.53 1.53 0 0 1-.606-1.343 1.62 1.62 0 0 1 .498-1.273c-.244-.86-.645-2.388.087-3.174a1.48 1.48 0 0 1 1.251-.433 4.99 4.99 0 0 1 4.831-1.75c1.625.266 2.828 1.132 3.099 2.2.271 1.067-.119 2.432-.358 3.168a1.63 1.63 0 0 1 .488 1.262 1.53 1.53 0 0 1-.607 1.343 3.53 3.53 0 0 1-1.419 2.78v1.83c1.446.316 2.85.801 4.182 1.447a.54.54 0 0 1 .277.31.54.54 0 0 1-.023.415.55.55 0 0 1-.52.308.6.6 0 0 1-.206-.053 17 17 0 0 0-4.333-1.44.545.545 0 0 1-.46-.543v-2.583a.54.54 0 0 1 .33-.499c.038 0 1.083-.541 1.083-2.361a.546.546 0 0 1 .499-.542.84.84 0 0 0 .092-.412.84.84 0 0 0-.06-.422.54.54 0 0 1-.498-.542q.032-.28.141-.541c.184-.58.541-1.783.357-2.638-.157-.623-1.083-1.208-2.226-1.392a3.85 3.85 0 0 0-3.943 1.554.55.55 0 0 1-.542.239c-.173-.038-.482-.076-.601.054-.228.243-.163.985.178 2.215q.08.248.093.51a.54.54 0 0 1-.499.54.84.84 0 0 0-.092.418.8.8 0 0 0 .092.412.54.54 0 0 1 .499.541c0 1.831 1.083 2.346 1.11 2.367a.54.54 0 0 1 .325.493V38.2a.54.54 0 0 1-.46.542c-1.53.286-3.014.78-4.41 1.468a.5.5 0 0 1-.233.048"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F5F7",
    strokeWidth: 2,
    d: "M356 33H196"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#connect_svg__e)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 356,
    y: 13,
    fill: "url(#connect_svg__f)",
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#connect_svg__g)",
    filter: "url(#connect_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m388.501 41.157-3.913-2.259v1.353H378v1.812h6.588v1.353zM364.406 37.08a4.99 4.99 0 0 0 4.984 4.984h1.36v-1.812h-1.36a3.175 3.175 0 0 1-3.171-3.172 3.175 3.175 0 0 1 3.171-3.172h1.36v-1.812h-1.36a4.99 4.99 0 0 0-4.984 4.984M384.343 28.924a4.99 4.99 0 0 0-4.984-4.985H378v1.813h1.359a3.175 3.175 0 0 1 3.172 3.172 3.175 3.175 0 0 1-3.172 3.171H378v1.813h1.359a4.99 4.99 0 0 0 4.984-4.984M370.75 23.94h-7.25v1.812h7.25zM377.093 22.127h-5.437v5.437h5.437zM377.093 30.283h-5.437v5.437h5.437zM377.093 38.44h-5.437v5.437h5.437z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#connect_svg__i)",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "M290 33h-78"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "connect_svg__a",
    width: 90,
    height: 90,
    x: 131,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1153_56910"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1153_56910",
    result: "effect2_dropShadow_1153_56910"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_1153_56910",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "connect_svg__d",
    width: 34,
    height: 34,
    x: 159,
    y: 17,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1153_56910"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1153_56910",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "connect_svg__e",
    width: 90,
    height: 90,
    x: 331,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1153_56910"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1153_56910",
    result: "effect2_dropShadow_1153_56910"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_1153_56910",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "connect_svg__h",
    width: 33,
    height: 33,
    x: 359.5,
    y: 17.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1153_56910"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1153_56910",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "connect_svg__b",
    x1: 176,
    x2: 176,
    y1: 13,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E94242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C81414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "connect_svg__f",
    x1: 376,
    x2: 376,
    y1: 13,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D4DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C727F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "connect_svg__i",
    x1: 291.592,
    x2: 210.408,
    y1: 31.5,
    y2: 31.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E01E5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E01E5A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "connect_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M163 20h26v26h-26z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "connect_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M363.5 20.5h25v25h-25z"
  })))));
};
export default SvgConnect;